


export const JobStatuses = ['none', 'queued', 'processing', 'completed', 'paused', 'aborted', 'failed'] as const;
export type TJobStatus = (typeof JobStatuses)[number];


export const RunningJobStatuses = ['queued', 'processing', 'paused'] as const;
export type TRunningJobStatus = (typeof RunningJobStatuses)[number];

